import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4e15138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-instructions-StepThree-component" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "img-container w-100 d-flex justify-content-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "img-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_floating_card = _resolveComponent("floating-card")!
  const _component_counter_modal = _resolveComponent("counter-modal")!
  const _component_await_modal = _resolveComponent("await-modal")!
  const _component_show_device_position_modal = _resolveComponent("show-device-position-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "3",
      stepTitle: this.StepContent.title,
      nextButtonActive: "",
      onNextStep: _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.StepContent.modalAwaitTime
          ? this.$refs['await-modal'].toggleModal(true)
          : this.$refs['counter-modal'].toggleModal(true);
        this.$refs['counter-modal'].stopCounter();
        this.$refs['counter-modal'].countdownTimeStart(
          this.StepContent.timerInMinutes
        );
        this.$refs['counter-modal'].initializeSound();
      }),
      onPreviousStep: _cache[2] || (_cache[2] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "steps-info open-sans-font",
          innerHTML: _ctx.StepContent.steps
        }, null, 8, _hoisted_2),
        (_ctx.StepContent.warningBeforeImageActive)
          ? (_openBlock(), _createBlock(_component_alert_box, {
              key: 0,
              class: "px-3",
              alert: "",
              stepContent: _ctx.StepContent,
              onOpenModal: _cache[0] || (_cache[0] = ($event: any) => (
            this.$refs['show-device-position-modal'].toggleModal(true)
          ))
            }, null, 8, ["stepContent"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "drop-image",
            src: _ctx.imagePath,
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.StepContent.warningActive)
            ? (_openBlock(), _createBlock(_component_alert_box, {
                key: 0,
                alert: "",
                stepContent: _ctx.StepContent
              }, null, 8, ["stepContent"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["stepTitle"]),
    (!_ctx.StepContent.modalAwaitTime)
      ? (_openBlock(), _createBlock(_component_counter_modal, {
          key: 0,
          ref: "counter-modal",
          onNextStep: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('nextStep')))
        }, null, 512))
      : (_openBlock(), _createBlock(_component_await_modal, {
          key: 1,
          ref: "await-modal",
          onNextStep: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('nextStep')))
        }, null, 512)),
    _createVNode(_component_show_device_position_modal, { ref: "show-device-position-modal" }, null, 512)
  ]))
}